import { i18n } from '../../i18n'

const AppSettingsModule = {
  namespaced: true,
  state: {
    locale: 'en'
  },
  mutations: {
    changeLocale (state, payload) {
      state.locale = payload.locale
      // change vue-i18n locale
      i18n.locale = state.locale
    }
  },
  actions: {
    changeLocale ({ commit }, payload) {
      commit('changeLocale', payload)
    }
  },
  getters: {}
}

export default AppSettingsModule
